module.exports = __webpack_public_path__ + "redux.f785d8.svg";